const LogoBox = { height: '31px', cursor: 'pointer' }

export { LogoBox }
